export default __webpack_public_path__ + "static/media/81_desktop.ea3d156e.jpg";